import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { breakpoints } from '$theme';
import { StyledAlignContent } from '../../shared/AlignContent/styled';
import { M75TinyMediaTextProps } from './types';
import { M76ContentPromotionProps } from '../M76ContentPromotion/types';

type StyledM75TinyContentProps = {
    mediaAlignment: M76ContentPromotionProps['mediaHorizontalAlignment'];
    backgroundColor: M75TinyMediaTextProps['backgroundColor'];
    isVisible: boolean;
};

export const StyledM75Tiny = styled.div({
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'grid',
});

export const StyledMediaArea = styled.div({
    gridArea: 'media',
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'none',
    [breakpoints.sm]: {
        display: 'block',
    },
});

export const StyledM75TinyContent = styled.div<StyledM75TinyContentProps>(
    ({ backgroundColor, isVisible, mediaAlignment, theme }) => ({
        backgroundColor,
        boxSizing: 'border-box',
        width: '100%',
        margin: '0 auto',
        gap: 0,
        display: 'flex',
        height: isVisible ? 125 : 0,
        flexDirection: mediaAlignment === 'right' ? 'column' : 'column-reverse',
        overflow: 'hidden',
        transition: 'height 0.3s ease-in-out',

        [breakpoints.sm]: {
            display: 'grid',
            gridAutoFlow: 'column',
            gridTemplateAreas: mediaAlignment === 'right' ? '"content media"' : '"media content"',
            gridTemplateColumns: '50% 50%',
            height: isVisible ? 180 : 0,
        },

        [`${StyledAlignContent}`]: {
            height: '100%',
            justifyContent: 'center',
            padding: theme.space['2'],
            [breakpoints.sm]: { padding: `0 ${theme.space['2']}` },
            [breakpoints.md]: {
                padding: `0 ${theme.space['4']}`,
            },
        },
        ['h1']: {
            fontSize: theme.fontSizes.wolf,
            [breakpoints.lg]: {
                fontSize: theme.fontSizes.elephant,
            },
        },
    }),

    // Ensures content aligns with the edge
    // if there is no background color
    ifProp({ backgroundColor: 'none' }, ({ mediaAlignment }) => ({
        [`${StyledAlignContent}`]: {
            paddingLeft: mediaAlignment === 'left' ? undefined : 0,
            paddingRight: mediaAlignment === 'right' ? undefined : 0,
        },
    })),
);
